import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, Partners, NewsletterSection, Banner, Process, PortfolioSection, Expertise } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About /> {/* About Section */}
        <Counter /> {/* Counter Section */}
        <Services /> {/* Services Slider */}
        <Expertise /> {/* Expertise section */}
        <Process /> {/* Process Slider */}
        <Banner /> {/* Banner Section */}
        <PortfolioSection /> {/* Portfolio Section */}
        <Testimonials /> {/* Testimonials Slider */}
        <Team /> {/* Team section */}
        <NewsletterSection /> {/* Newsletter subscription Section */}
        <Partners /> {/* Partners Slider */}

      </section>

    </>
  );
}

export default AboutUs;